import jsPDF from "jspdf";
import "jspdf-autotable";

type InvoiceData = {
    orderInvoices: {
        dbId: string;
        createdAt: string;
        dueDate: string;
        items: {
            name: string;
            quantity: number;
            pricePerUnit: number;
            totalPrice: number;
        }[];
        totalPriceWithoutTax: number;
        totalTax: number;
        totalShippingCost: number;
        totalDiscountedAmount: number;
        totalPrice: number;
        note?: string;
    }[];
    invoiceSetting: {
        storeName: string;
        storeAddress: string;
        city: string;
        country: string;
        contactPhone: string;
        contactEmail: string;
    };
};

const generateBulkReceiptPOS = (data: InvoiceData) => {
    const doc = new jsPDF({ unit: "mm", format: [80, 297] }); // Thermal printer size
    const { orderInvoices, invoiceSetting } = data;

    orderInvoices.forEach((invoice, index) => {
        if (index > 0) doc.addPage();
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(invoiceSetting.storeName, 40, 10, { align: "center" });
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(invoiceSetting.storeAddress, 40, 15, { align: "center" });
        doc.text(`${invoiceSetting.city}, ${invoiceSetting.country}`, 40, 20, { align: "center" });
        doc.text(`Tel: ${invoiceSetting.contactPhone}`, 40, 25, { align: "center" });
        doc.text(`Email: ${invoiceSetting.contactEmail}`, 40, 30, { align: "center" });

        doc.setFontSize(9);
        doc.text("--------------------------------", 40, 35, { align: "center" });
        doc.text(`Invoice #: ${invoice.dbId}`, 10, 40);
        doc.text(`Date: ${new Date(invoice.createdAt).toLocaleDateString()}`, 10, 45);
        doc.text("--------------------------------", 40, 55, { align: "center" });

        let startY = 60;
        (doc as any).autoTable({
            startY,
            head: [["Item", "Qty", "Price", "Total"]],
            body: invoice.items.map((item) => [
                item.name,
                String(item.quantity),
                String(item.pricePerUnit),
                String(item.totalPrice)
            ]),
            theme: "plain",
            styles: { fontSize: 8, cellPadding: 1 },
            margin: { left: 10 }
        });

        startY = (doc as any).lastAutoTable.finalY + 5;
        doc.setFontSize(9);
        doc.text(`Subtotal: ${invoice.totalPriceWithoutTax}`, 10, startY);
        doc.text(`Tax: ${invoice.totalTax}`, 10, startY + 5);
        doc.text(`Shipping: ${invoice.totalShippingCost}`, 10, startY + 10);
        doc.text(`Discount: -${invoice.totalDiscountedAmount}`, 10, startY + 15);
        doc.text(`Total: ${invoice.totalPrice}`, 10, startY + 20);

        if (invoice.note) {
            doc.text(`Note: ${invoice.note}`, 10, startY + 30);
        }

        doc.text("--------------------------------", 40, startY + 35, { align: "center" });
        doc.text("Thank you for your purchase!", 40, startY + 40, { align: "center" });
    });

    doc.autoPrint();
    const pdfBlob = doc.output("blob");
    const blobUrl = URL.createObjectURL(pdfBlob);
    const newWindow = window.open(blobUrl, "_blank");
    if (newWindow) {
        newWindow.onload = () => URL.revokeObjectURL(blobUrl);
    }
};

export { generateBulkReceiptPOS };
